import type { Variant } from '@storefront/lib-global/codegen/types';
import { StockStatus } from '@storefront/lib-global/codegen/types';

export const getAvailableStockQuantity = (
  variants: Variant[],
  selectedSku: string,
  selectedWidth: string,
  selectedSize: string,
): number =>
  variants
    .filter(
      (variant) =>
        variant.stock.status === StockStatus.INSTOCK &&
        (selectedSize ? variant.size === selectedSize : true) &&
        (selectedWidth ? variant.fitLabel === selectedWidth : true),
    )
    .reduce((acc, currentValue) => {
      const hasSelectedValue = selectedSize || selectedWidth;
      return hasSelectedValue || selectedSku ? acc + currentValue.stock.availableQuantity : 0;
    }, 0);
